import { z } from "zod";

import { civilityDtoSchema } from "@/types/backoffice/dto/subscriber/civility-dto.ts";
import { mailDtoSchema } from "@/types/backoffice/dto/subscriber/mail-dto.ts";
import { phoneDtoSchema } from "@/types/backoffice/dto/subscriber/phone-dto.ts";

export enum EMyVoltalisAccess {
  MY_VOLTALIS_2016 = "MY_VOLTALIS_2016",
  MY_VOLTALIS_2022 = "MY_VOLTALIS_2022",
}

export enum EMyVoltalisAccessLabel {
  MY_VOLTALIS_2016 = "MyVoltalis 2016",
  MY_VOLTALIS_2022 = "MyVoltalis 2022",
}

export const subscriberDtoSchema = z.object({
  id: z.number(),
  civility: civilityDtoSchema.nullable(),
  firstname: z.string(),
  lastname: z.string(),
  login: z.string().nullable(),
  myVoltalisAccess: z.nativeEnum(EMyVoltalisAccess).nullable(),
  hasMyVoltalisAccess: z.boolean(),
  privileged: z.boolean(),
  vip: z.boolean(),
  validPhoneList: z.array(phoneDtoSchema),
  validMailList: z.array(mailDtoSchema),
  hasPassword: z.boolean(),
});

export type TSubscriberDto = z.infer<typeof subscriberDtoSchema>;
